import { render } from "./AposInputAttachment.vue?vue&type=template&id=7db9801c"
import script from "./AposInputAttachment.vue?vue&type=script&lang=js"
export * from "./AposInputAttachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"schema/ui/apos/components/AposInputAttachment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7db9801c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7db9801c', __exports__)) {
    api.reload('7db9801c', __exports__)
  }
  
  module.hot.accept("./AposInputAttachment.vue?vue&type=template&id=7db9801c", () => {
    api.rerender('7db9801c', render)
  })

}


export default __exports__